import { render } from "./BundleHomePage.vue?vue&type=template&id=71154398&scoped=true"
import script from "./BundleHomePage.vue?vue&type=script&lang=js"
export * from "./BundleHomePage.vue?vue&type=script&lang=js"

import "./BundleHomePage.vue?vue&type=style&index=0&id=71154398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71154398"]])

export default __exports__